import { handleImageError, PLACEHOLDER_IMG } from "../utils/imageFallback";
import "./ProductCard.css";

export default function ProductCard({ product, index = 0 }) {
  const delayClass = `delay-${Math.min((index % 6) + 1, 6)}`;
  const { name, brand, size, img, subcategory } = product ?? {};

  /* brand/size are missing on a few data rows, so every use is guarded. */
  const showBrand = brand && brand !== "Imported";
  const meta = [showBrand ? `by ${brand}` : null, subcategory]
    .filter(Boolean)
    .join(" · ");

  return (
    <div className={`product-card animate ${delayClass}`}>
      <div className="product-img-wrap">
        <img
          className="product-img"
          src={img || PLACEHOLDER_IMG}
          alt={name || "Product"}
          loading="lazy"
          decoding="async"
          onError={handleImageError}
        />
        {brand && <span className="product-brand-badge">{brand}</span>}
      </div>
      <div className="product-info">
        <div className="product-name">{name || "Unnamed product"}</div>
        {meta && <div className="product-brand">{meta}</div>}
        {size && <div className="product-size">📦 {size}</div>}
      </div>
    </div>
  );
}
